import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Updating from '../components/common/Updating';
import Error from '../components/common/Error';

import DashboardKPI from "../components/rts/Dashboard/DashboardKPI";
import DashboardPinned from '../components/rts/Dashboard/DashboardPinned';
import DashboardLocked from '../components/rts/Dashboard/DashboardLocked';
import DashboardCrew from '../components/rts/Dashboard/DashboardCrew';
import DashboardProject from '../components/rts/Dashboard/DashboardProject';
import DashboardLocation from '../components/rts/Dashboard/DashboardLocation';
import DashboardAlert from '../components/rts/Dashboard/DashboardAlert';

import { useSessionContext } from '../contexts/SessionContext';

export default function DashboardPage( props ) {
    //console.debug("RTS Break DashboardPage");

    const {sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const [isUpdating, setIsUpdating] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);


    const setCurData = useCallback((pFilter) => {
        setIsUpdating(true);
        let apiURL = apiRoot + "/LoadList/SetCustomerCurData";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            setIsUpdating(false);
        })
        .catch(error => {
            setIsUpdating(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);


    useEffect(() => {
        props.setIsModalFx(false);
        setCurData(sessionCustomer.customer);
    }, [props, sessionCustomer.customer, setCurData]); 


    const handleChange = (e, curIndex) => {
      setTabIndex(curIndex);
    };


    if(hasError){
        return(
            <Error />
        );
    }


    if(isUpdating){
        return(
            <Updating />
        );
    };   

    
    return(
        <>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb:1 }}>
            <Tabs value={tabIndex} onChange={handleChange}>
                {
                sessionCustomer.accessLevel > 1 || sessionCustomer.fullAccess === 1
                ?
                    <Tab label="Overview" value={0}  />
                :
                    ""
                }
                <Tab label="Pinned" value={1} />
                {
                sessionCustomer.accessLevel >= 50
                ?
                    <Tab label="Locked" value={2} />
                :
                    ''
                }
                <Tab label="Crews" value={3} />
                {
                sessionCustomer.accessLevel >= 50
                ?
                    <Tab label="Projects" value={4} />
                :
                    ''
                }
                {
                sessionCustomer.accessLevel >= 50
                ?
                    <Tab label="Locations" value={5} />
                    :
                    ''
                }
                {
                sessionCustomer.accessLevel >= 50
                ?
                    <Tab label="Alerts" value={6} />
                    :
                    ''
                }
            </Tabs>
        </Box>

        {
        tabIndex === 1
        ?
            <DashboardPinned IsModal />
        :
            tabIndex === 2
            ?
                <DashboardLocked IsModal />
            :
                tabIndex === 3
                ?
                    <DashboardCrew IsModal />
                :
                    tabIndex === 4
                    ?   
                        <DashboardProject IsModal />
                    :
                        tabIndex === 5
                        ?   
                            <DashboardLocation IsModal />
                        :
                            tabIndex === 6
                            ?
                                <DashboardAlert IsModal />
                            :
                                sessionCustomer.accessLevel > 1 || sessionCustomer.fullAccess === 1
                                ?
                                    <DashboardKPI IsModal />
                                :
                                    <DashboardPinned IsModal />

        }
        </>
    );
}
